import React, { useRef, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import {
    updateItemInfo,
    updateItemImage
} from '../../../actions/items';
import { showToastMessage } from '../../../actions/toastmessage';
import { Regex } from '../../../utills.js';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import SliderWrapper from 'jd-library/SliderWrapper';
import style from './upload-from-url.scss';
import Button from 'jd-library/Button';
import historyHandler from 'jd-library/historyHandler';
import axios from 'axios';
import AnimateOnHover from 'jd-library/AnimateOnHover';
let ValidImageRegex = (/\.(jpe?g|png|webp)$/i);
const UploadFromUrl = (props) => {
    let imageUrlRef = useRef(null);
    let [showLoader, setLoader] = useState(false);
    let [uploadUrl, setuploadUrl] = useState('');
    let [errorText, setErrorText] = useState('');

    const showError = (errorMsg) => {
        setErrorText(errorMsg);
        props.showToastMessage({
            showToastMessage: true,
            message: errorMsg,
            duration: 5000
        });
    }
    const onUrlOnChange = (e) => {
        let x = e.currentTarget.value;
        let urlData = x && (x.charAt(0).toLowerCase() + x.slice(1));
        setuploadUrl(urlData);
        setErrorText('');
    }
    const saveCB = () => {
        let param;
        if (uploadUrl == '') {
            showError('Please Enter Image URL');
            return;
        } else if (!Regex.urlRegex.test(uploadUrl)) {
            showError('Please Enter Valid Image URL');
            return;
        }
        if (props.type == 'itemCategory') {
            param = {
                imageUrl: uploadUrl,
                module: 'groups'
            }
        } else {
            param = {
                imageUrl: uploadUrl
            }
        }
        setLoader(true);
        axios({
            method: 'GET',
            url: '/marketplace/products/ajax/uploadProductImageThroughUrl.service',
            params: param
        }).then((res) => {
            setLoader(false);
            if (res.data.status == "success") {
                if(props.customUpload){
                    props.customUpload({...res.data, createdfrom: 'url'})
                }else {
                    props.updateProductImage({ imageUrl: res.data.imgURL, createdfrom: 'url' })
                }
                historyHandler.closeCurrent();
            }
            if (res.data.message == "Enter valid web link" || res.data.isError == 'true') {
                if (ValidImageRegex.test(uploadUrl)) {
                    const errorMessage = res.data.message || 'Unable to Fetch Image from URL';
                    showError(errorMessage);
                } else {
                    showError('Only JPG, JPEG, PNG & WEBP Files are Supported');
                }
            }
        }).catch((error) => {
            setLoader(false);
        })
    }
    const onPasteClick = () => {
        if(window.Android && window.Android.getClipboardData){
            const text = window.Android.getClipboardData();
            if(text){
                setuploadUrl(text);
                setErrorText('');
            }
        } else{
            navigator.clipboard.readText().then(text => {
                if(text) {
                    setuploadUrl(text);
                    setErrorText('');
                }
            });
        }
    }
    const clearValue = useCallback(() => {
        setuploadUrl('');
        setErrorText('')
    }, []);
    return (
        <div>
            <SliderWrapper
                header={{
                    heading: 'Add Image Link',
                    variant: 'secondary',
                    className: style['upload-url-slider-header']
                }}
                onHidden={(e) => { props.onHidden() }}
                slider={{
                    className: style['upload-url-edit-slider']
                }}
            >
                <InputWithMovingLabel
                    ref={imageUrlRef}
                    label='Image Link'
                    holderClass='image-url-input'
                    errorMessage={
                        errorText
                    }
                    input={{
                        onChange: e => { onUrlOnChange(e) },
                        value: uploadUrl,
                        placeHolder: 'http://',
                        autoFocus: true
                    }}
                    inputGroupProps={{
                        rightIconClass: uploadUrl ? `icon-HDRcross ${style['cross-icon']}` : null,
                        onRightIconClick: clearValue,
                        rightSection: () => {
                            if(uploadUrl || !navigator.clipboard) {
                                return null;
                            }

                            return (
                                <AnimateOnHover 
                                    className={style['paste-btn']}
                                    onClick={onPasteClick}
                                >Paste</AnimateOnHover>
                            )
                        }
                    }}
                />
                <div className={style['btn-wrap']}>
                    <Button
                        size='lg'
                        showLoader={showLoader}
                        className={style['upload-url-btn']}
                        clickHandler={saveCB}
                    >
                        Upload Image
                    </Button>
                </div>
            </SliderWrapper>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        session: state.session,
        deviceData: state.deviceData,
        itemInfo: state.items.itemInfo,
        errors: state.items.errors
    };
};
export default connect(mapStateToProps, {
    updateItemInfo,
    updateItemImage,
    showToastMessage
})(UploadFromUrl);